(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[579],{

/***/ 8998:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/chart",
      function () {
        return __webpack_require__(2033);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_layout_AppLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1835);
/* harmony import */ var _components_dataDisplay_chartAccordion_ChartAccordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2101);



const ChartPage = (param)=>{
    let { quotesData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_AppLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: "Chart",
        robots: "noindex,nofollow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_dataDisplay_chartAccordion_ChartAccordion__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            quotesData: quotesData
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ChartPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [678,520,885,174,774,888,179], function() { return __webpack_exec__(8998); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);